<template>
  <div class="">
    <!--
      StoryID: {{ $route.params.storyID }}<br />
      PageID: {{ $route.params.pageID }}
    -->
    <div v-if="loading">
      <loading></loading>
    </div>
    <!-- Not loading -->
    <div v-else-if="errtext" style="text-align: center;">
        <h2 class="red--text">{{errtext}}</h2>
    </div>
    <div v-else>
        <!-- There is no error -->
        <v-row justify="center">
          <router-link :to="{name:'TitlePage', params:{'storyID':$route.params.storyID}}" class="title">{{title}}</router-link>
        </v-row>
        <hr />

        <!-- Decide what to show -->
        <PageView v-if="status=='PAGEAVAILABLE'" @reloadPage="loadPage" :author="author" :title="title" :text="text" :options="options"></PageView>
        <PageLocked v-else-if="status=='LOCKED_NOEDIT'"></PageLocked>
        <EditView v-else-if="status=='LOCKED_CANEDIT' || this.$route.query.first" @setPageReady="loadPage(true)"></EditView>
        <AskToLoginView v-else-if="status=='UNLOCKED_EDITABLE'" :userPassword="storyPasswords" @setLockedCanEdit="status='LOCKED_CANEDIT'"></AskToLoginView>
        <CannotEdit v-else-if="status=='UNLOCKED_NOEDIT'"></CannotEdit>

        <v-row v-if="showSubscribe == true" class="subheading" align="center" justify="center">
          <span>Don't forget to
            <router-link :to="{name:'Subscribe', params:{'title':this.title, 'storyID':$route.params.storyID}}">
             subscribe to updates</router-link>
          to this story so you know when anyone adds a page!
          </span>
        </v-row>

    </div>
  </div>
</template>

<script>
import config from '../config.js'
import PageView from '../components/PageView.vue'
import PageLocked from '../components/PageLocked.vue'
import EditView from '../components/EditView.vue'
// import AskToEditView from '../components/AskToEditView.vue'
import AskToLoginView from '../components/AskToLoginView.vue'
import loading from '@/components/Loading.vue'
import CannotEdit from '@/components/CannotEdit'

export default {
  name: 'ReadStory',
  components: {
    PageView, PageLocked, EditView, AskToLoginView, loading, CannotEdit
  },
  data () {
    return {
      showSubscribe: false,
      errtext: null,
      loading: true,
      title: null,
      status: null,
      text: null,
      options: null,
      author: null,
      storyPasswords: null,
      lockID: null,
      pageID: null
    }
  },
  mounted () {
    // Load the current page
    this.loadPage()
  },
  methods: {

    loadPage (doShowSubscribe = 'false') {
      this.showSubscribe = doShowSubscribe
      this.loading = true
      this.errtext = null
      const dynFunction = config.getFunctions().httpsCallable('dynFunction')

      // Get the cookies stored (maybe) by the user
      this.storyPasswords = this.$cookies.get('storyPasswords')
      this.lockID = this.$cookies.get('lockID')
      this.pageID = this.$route.params.pageID // Maybe undefined

      // console.log('ReadStoryMounted lockID:' + this.lockID)
      dynFunction({ call: 'getPage', params: this.$route.params, storyPasswords: this.storyPasswords, lockID: this.lockID }).then((rc) => {
        // console.log('getPage: ', rc)

        this.status = rc.data.status // See index.js for possible values
        this.title = rc.data.title
        this.text = rc.data.text
        this.options = rc.data.options
        this.loading = false
        this.author = rc.data.author
        this.pageID = rc.data.pageID
      }).catch((err) => {
        console.error('Error readStory: ' + err)
        this.errtext = err
        this.loading = false
      })
    }

  }

  // Load the given page or
  // show an error if the story doesn't exist
  // show something to "write the page" if the page doesn't exist?
}
</script>
